export const UPDATE_UNITES = 'UPDATE_UNITES';
export const UPDATE_FRACTIONS = 'UPDATE_FRACTIONS';
export const TOGGLE_VISIBILITY_NUMBERS = 'TOGGLE_VISIBILITY_NUMBERS';